import Reveal from "../components/Reveal";
import { ArrowRight, Mail, Calendar, Table, LinkIcon, FileText, Folder, DollarSign } from "lucide-react";
import Logo from "@/components/Logo";

const TOOLS = [
  { icon: Mail, label: "Email" },
  { icon: Calendar, label: "Calendar" },
  { icon: Table, label: "Spreadsheets" },
  { icon: LinkIcon, label: "Booking tool" },
  { icon: FileText, label: "Forms" },
  { icon: Folder, label: "Documents" },
  { icon: DollarSign, label: "Invoicing" },
];

export default function ProblemSection() {
  return (
    <section
      data-testid="problem"
      className="py-24 lg:py-32"
      style={{ background: "#FFFFFF" }}
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <Reveal className="max-w-3xl">
          <h2 className="font-display font-extrabold text-[34px] sm:text-[44px] leading-[1.08] tracking-[-0.02em] text-[#1A2A3A] mb-4">
            Stop running your business from six different tools.
          </h2>
          <p className="text-[16px] sm:text-[17px] text-[#57534E] leading-relaxed">
            Every disconnected tool is another tab, another password, another
            place to lose something. ClientDesk VA replaces that patchwork with
            one workspace that already knows your clients, your calendar and
            your money.
          </p>
        </Reveal>

        <Reveal delay={100} className="mt-14">
          <div className="grid lg:grid-cols-[1fr_auto_auto] gap-6 lg:gap-8 items-center">
            <div className="flex flex-wrap gap-2.5">
              {TOOLS.map(({ icon: Icon, label }) => (
                <div
                  key={label}
                  className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full border border-[#E8E2D9] bg-[#FAF7F2] text-[13px] text-[#57534E]"
                >
                  <Icon size={14} strokeWidth={1.7} className="text-[#A8A29E]" />
                  {label}
                </div>
              ))}
            </div>

            <ArrowRight
              className="hidden lg:block text-[#A8A29E]"
              size={28}
              strokeWidth={1.5}
              aria-hidden="true"
            />

            <div className="inline-flex items-center gap-3 px-5 py-3.5 rounded-2xl bg-[#334E68] text-white shadow-[0_20px_40px_-20px_rgba(51,78,104,0.5)]">
              <Logo variant="icon-only" size={24} onDark />
              <div className="font-display font-bold text-[15px] tracking-[-0.01em]">
                ClientDesk VA
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
